import { useCallback, useLayoutEffect, useMemo, useRef, useState } from 'react';
import cls from 'classnames';
import { RightOutlined, DownOutlined } from '@ant-design/icons';

import styles from './index.module.scss';
export default (props: Record<string, any>) => {
  const { list = [] } = props;
  const [pullMsg, setPullMsg] = useState<string>('下拉查看更多');
  const mainRef = useRef<any>(null);
  const gotoLink = useCallback((item: any) => {
    console.log('gotoLink===', item);
    if (item?.redirectUrl) {
      window.open(item?.redirectUrlH5 || item?.redirectUrl);
    }
  }, []);
  const scrollHeight = useCallback(() => {
    console.log('mainRef.value', mainRef.current?.scrollHeight, mainRef.current?.scrollTop);
    if (mainRef.current?.scrollTop + 700 > mainRef.current?.scrollHeight) {
      setPullMsg('已经到底啦');
    } else {
      setPullMsg('下拉查看更多');
    }
  }, [setPullMsg]);
  const productionArra = useMemo(() => {
    const brandNodes: Array<any> = [];
    let childrens: Array<any> = [];
    list.forEach((item: any, index: number) => {
      childrens.push(
        <div className={cls('flex1', 'flex', 'v-center', 'h-center', styles['production-cell'])} key={index}>
          <div className={cls(styles['inner-cell'], 'flex', 'v-center')} onClick={() => gotoLink(item)}>
            <img src={item.url} />
            <div className={styles['desc-info']}>
              <p dangerouslySetInnerHTML={{ __html: item.title }}></p>
            </div>
            <a className={styles['more']}>
              <span>了解更多</span>
              <RightOutlined />
            </a>
          </div>
        </div>
      );
      if ((index + 1) % 2 == 0 || index === list.length - 1) {
        if (childrens.length) {
          brandNodes.push(
            <div key={index} className={cls(styles['production-row'], 'flex')}>
              {childrens}
            </div>
          );
        }
        childrens = [];
      }
    });
    return brandNodes;
  }, [list]);
  return (
    <div className={cls(styles['production-content'], 'mt30')}>
      <div className={styles['sub-title']}>热销产品</div>
      <div className={styles['production-main']} ref={mainRef} onScroll={scrollHeight}>
        {productionArra}
      </div>
      <div>
        <span>{pullMsg}</span>
        <DownOutlined />
      </div>
    </div>
  );
};
